import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { Play, ArrowRight, CheckCircle } from 'lucide-react';
import { courseInfo } from '../data/mock';

const HeroSection = ({ onEnrollClick, onPreviewClick }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  
  useEffect(() => {
    // Trigger animations on mount
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const highlights = [
    "Industry-recognized certification",
    "Hands-on projects with real data",
    "Lifetime access & updates"
  ];

  return (
    <section className="hero-section" data-testid="hero-section">
      <div className="hero-content">
        <div className={`hero-badge animate-fade-in ${isLoaded ? 'is-visible' : ''}`}>
          <span className="badge-dot"></span>
          New 2026 Curriculum Available
        </div>
        
        <h1 className={`hero-title animate-slide-up ${isLoaded ? 'is-visible' : ''} stagger-1`}>
          {courseInfo.title}
        </h1>
        
        <p className={`hero-subtitle animate-slide-up ${isLoaded ? 'is-visible' : ''} stagger-2`}>
          {courseInfo.description}
        </p>

        <ul className={`hero-highlights animate-slide-up ${isLoaded ? 'is-visible' : ''} stagger-3`}>
          {highlights.map((item, index) => (
            <li key={index} className="highlight-item">
              <CheckCircle className="highlight-icon" />
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <div className={`hero-actions animate-slide-up ${isLoaded ? 'is-visible' : ''} stagger-4`}>
          <Button 
            className="btn-primary hero-cta hover-glow"
            onClick={onEnrollClick}
            data-testid="hero-enroll-btn"
          >
            Start Learning Today
            <ArrowRight className="btn-icon" />
          </Button>
          
          <Button 
            className="btn-secondary hero-preview hover-lift"
            onClick={onPreviewClick}
            data-testid="hero-preview-btn"
          >
            <Play className="btn-icon-left" />
            Watch Preview
          </Button>
        </div>

        <div className={`hero-stats animate-fade-in ${isLoaded ? 'is-visible' : ''} stagger-5`}>
          {courseInfo.stats.map((stat, index) => (
            <div key={index} className="stat-item hover-scale">
              <span className="stat-value">{stat.value}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
